/** Comments panel width (% of presenter body), with px floor/ceiling. */
export const PRESENTER_COMMENTS_PANEL_WIDTH_PERCENT = 30;

/** Min/max comments panel width (px). */
export const PRESENTER_COMMENTS_PANEL_MIN_WIDTH_PX = 240;
export const PRESENTER_COMMENTS_PANEL_MAX_WIDTH_PX = 400;

/** Shared width for overlay (unpinned) and docked (pinned) comments panel. */
export const PRESENTER_COMMENTS_PANEL_WIDTH = `clamp(${PRESENTER_COMMENTS_PANEL_MIN_WIDTH_PX}px, ${PRESENTER_COMMENTS_PANEL_WIDTH_PERCENT}%, ${PRESENTER_COMMENTS_PANEL_MAX_WIDTH_PX}px)`;

/** Auto-close delay when pointer leaves unpinned panel (ms). */
export const PRESENTER_COMMENTS_AUTO_CLOSE_DELAY_MS = 300;

/** Slide transition duration (ms) — keep in sync with Tailwind duration-300. */
export const PRESENTER_COMMENTS_PANEL_TRANSITION_MS = 300;

/** ~3 lines in the comments panel at text-sm; longer messages get Read more / Read less. */
export const PRESENTER_COMMENT_MESSAGE_COLLAPSED_MAX_CHARS = 180;
